import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoSpacesPipe } from '../pipes/noSpaces.pipe';
import { PhoneDirective } from './phone.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PhoneDirective],
  exports: [PhoneDirective],
  providers: [NoSpacesPipe],
})
export class PhoneDirectiveModule {}
